import _ from 'underscore';
import React, { useState, memo } from 'react';
import PropTypes from 'prop-types';
import { InstrumentationContext } from '@bingads-webui-react/hoc-with-instrumentation';

export const InstrumentationServiceContext = React.createContext([null, _.noop]);

export const InstrumentationWithServiceProvider = memo((props) => {
  const {
    context,
    children,
  } = props;

  const [instrumentationService, setInstrumentationService] = useState(context);
  const { instrumentation = null } = instrumentationService || {};

  return (
    <InstrumentationServiceContext.Provider value={[instrumentationService, setInstrumentationService]}>
      <InstrumentationContext.Provider value={instrumentation}>
        {children}
      </InstrumentationContext.Provider>
    </InstrumentationServiceContext.Provider>
  );
});

InstrumentationWithServiceProvider.propTypes = {
  context: PropTypes.shape({
    logger: PropTypes.shape({}).isRequired,
    instrumentation: PropTypes.shape({}).isRequired,
  }).isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};
